import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cx from "../privacy-policy/privacypolicy.module.scss";
import TopNavigation from '../topNavigation/TopNavigation';

function PaymentPolicy() {
    const [change, setIsChange] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <TopNavigation change={change} />
            <section className={cx.privacypolicy}>
                <Container>
                    <Row className="flex-wrap-reverse">
                        <Col md={8}>
                            <div className={cx.content_main}>
                                <h2>Payment Policy</h2>
                                <p>
                                    At htraction, we strive to offer smooth and secure payment experience for our customers. This Payment Policy outlines the terms and conditions related to payments made on our platform.
                                </p>

                                <h3>1. Accepted Payment Methods</h3>
                                <p>We accept the following modes of payment:</p>
                                <ul>
                                    <li>Credit/Debit Cards (Visa, MasterCard, RuPay, etc.)</li>
                                    <li>Net Banking</li>
                                    <li>UPI (Google Pay, PhonePe, Paytm, etc.)</li>
                                    <li>Wallets (as supported by our payment gateway)</li>
                                    <li>Other payment options as made available on the platform</li>
                                </ul>

                                <h3>2. Currency</h3>
                                <p>
                                    All transactions are processed in Indian Rupees (INR). Prices displayed on our website are inclusive of applicable taxes unless stated otherwise.
                                </p>

                                <h3>3. Payment Gateway</h3>
                                <p>
                                    We use a secure third-party payment gateway (Razorpay) to process transactions. Your payment details are handled securely in compliance with PCI-DSS standards.
                                </p>

                                <h3>4. Order/Transaction Confirmation</h3>
                                <p>
                                    Once the payment is successfully processed, you will receive an email and/or SMS confirmation with details. Please keep this confirmation for your records.
                                </p>

                                <h3>5. Refund &amp; Cancellation Policy</h3>
                                <p>
                                    Refunds &amp; Cancellations are not permitted.
                                </p>

                                <h3>6. Failed Transactions</h3>
                                <p>
                                    In case of a failed transaction but a deduction of funds from your account, the amount will be automatically refunded by the payment gateway within 5 working days.
                                </p>

                                <h3>7. Security</h3>
                                <p>
                                    We take the security of your payment information seriously. Our website uses SSL encryption and works only with reputed payment gateway providers to ensure your data is protected.
                                </p>

                                <h3>8. Contact Us</h3>
                                <p>
                                    If you have any questions or concerns regarding payments, please contact us at:<br />
                                    📧 <a href="mailto:hello@htraction.com">hello@htraction.com</a>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default PaymentPolicy;
